module.exports = __webpack_public_path__ + "img/poison.183135e9.svg";